const posts = [
  {
    title: 'Show Blue Ticks After Reply: A Smart Read Receipt Feature in GBWhatsApp',
    poster: require('@/assets/blog-1.webp'),
    desc: 'GBWhatsApp lets you to read messages privately, only a blue checkmark is displayed after a reply, giving you privacy of your reading.',
    routeName: 'show-blue-ticks-after-reply-in-gbwhatsapp',
    url: '/show-blue-ticks-after-reply-in-gbwhatsapp/',
    date: '2025-12-17',
    keywords: 'Show Blue Ticks After Reply in GBWhatsApp',
  },
  {
    title: 'GBWhatsApp VS FMWhatsApp: Why GBWhatsApp Takes the Lead',
    poster: require('@/assets/blog-2.webp'),
    desc: 'GBWhatsApp outperforms FMWhatsApp in privacy, stability, and anti-ban features, making it the preferred WhatsApp MOD for secure messaging.',
    routeName: 'gbwhatsapp-vs-fmwhatsapp',
    url: '/gbwhatsapp-vs-fmwhatsapp/',
    date: '2026-01-07',
    keywords: 'GBWhatsApp vs FMWhatsApp',
  },
  {
    title: 'How to Fix GB WhatsApp Ban and Avoid Getting Banned Again',
    poster: require('@/assets/blog-new.png'),
    desc: 'Learn how to fix GB WhatsApp ban, recover restricted accounts, and reduce the risk of future bans with simple troubleshooting steps.',
    routeName: 'fix-gb-whatsapp-ban',
    url: '/fix-gb-whatsapp-ban/',
    date: '2026-07-23',
    keywords: 'fix GB WhatsApp ban, GB WhatsApp banned, avoid GB WhatsApp ban',
  },
];

export function getPostByUrl(url) {
  return posts.find((post) => post.url === url);
}

export function getPostByRouteName(routeName) {
  return posts.find((post) => post.routeName === routeName);
}

export default posts;
